export default __webpack_public_path__ + "static/media/20s_block_hit_bottom.7beae84b.mp3";